import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';

/**
 * Stamps X-Parent-Domain on every API call. The Widget API reads the caller origin from this
 * header rather than the browser Origin header, and rejects a missing or unrecognised value with 403.
 */
@Injectable()
export class ParentDomainInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'X-Parent-Domain': window.location.origin
      }
    });
    return next.handle(request);
  }
}
